export const STORY_SORT_OPTIONS = {
  VOLUME: 'volume',
  RECENCY: 'recency',
}
